import React, { useEffect } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import Select from "@components/component-library/Atoms/Select/Select";
import Texfield from "@components/component-library/Atoms/TextField/Texfield";
import {
  AUSTRALIAN_DRIVERS_LICENSE_CARD_NUMBER,
  AUSTRALIAN_DRIVERS_LICENSE_NUMBER,
  AUSTRALIAN_PASSPORT_NUMBER,
  CENTRELINK_CUSTOMER_REF_NUM,
  CENTRELINK_NAME,
  MEDICARE_CARD_NUMBER,
  MEDICARE_INDIVIDUAL_NUMBER,
  MEDICARE_NAME_LINE,
  NZ_DRIVERS_LICENSE_NUMBER,
  NZ_DRIVERS_LICENSE_VERSION,
  NZ_PASSPORT_NUMBER,
} from "@util/regex";
import { states } from "@util/states";

const IdCheckModalDocumentSection = () => {
  const { control } = useFormContext();

  const selectedMethod = useWatch({
    control,
    name: "method",
  });

  useEffect(() => console.log("METHOD: ", selectedMethod), [selectedMethod]);

  switch (selectedMethod) {
    case "Australian Passport":
      return (
        <>
          <Texfield
            label="* Document number"
            name="number"
            placeholder="As displayed on your ID"
            rules={{
              required: "Document number required",
              pattern: { value: AUSTRALIAN_PASSPORT_NUMBER, message: "Enter a valid passport number." },
            }}
            screenSpan="full-screen"
          />
        </>
      );
    case "Medicare Card":
      return (
        <>
          <Texfield
            label="* Medicare number"
            name="cardnumber"
            placeholder="As displayed on your ID"
            rules={{
              required: "Medicare number required",
              pattern: { value: MEDICARE_CARD_NUMBER, message: "Enter a valid medicare number" },
            }}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Full name"
            name="nameline1"
            placeholder="As displayed on your ID"
            rules={{
              required: "Full name required",
              maxLength: { value: 27, message: "Maximum 27 characters" },
              pattern: { value: MEDICARE_NAME_LINE, message: "Enter a valid name" },
            }}
            screenSpan="full-screen"
          />
          <Select
            label="* Card type"
            name="cardtype"
            rules={{ required: "Card type is required" }}
            placeholder="As displayed on your ID"
            selectOptions={["Blue", "Green", "Yellow"]}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Card expiry"
            name="expiry"
            placeholder="As displayed on your ID"
            rules={{ required: "Card expiry is required" }}
            screenSpan="full-screen"
            type="date"
          />
          <Texfield
            label="* Individual reference number"
            name="individualnumber"
            type="number"
            placeholder="The 1-digit number next to your name"
            rules={{
              required: "Reference number required",
              pattern: {
                value: MEDICARE_INDIVIDUAL_NUMBER,
                message: "Invalid Reference number. Must be 1 digit.",
              },
            }}
            onWheel={(event) => event.currentTarget.blur()}
          />
        </>
      );
    case "Centrelink Card":
      return (
        <>
          <Texfield
            label="* Customer Reference Number"
            name="customerreferencenumber"
            placeholder="As displayed on your ID"
            rules={{
              required: "Customer reference number required",
              pattern: { value: CENTRELINK_CUSTOMER_REF_NUM, message: "Invalid customer reference number" },
            }}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Full name"
            name="name"
            placeholder="As displayed on your ID"
            rules={{
              required: "Full name required",
              maxLength: { value: 32, message: "Maximum upto 32 characters." },
              pattern: { value: CENTRELINK_NAME, message: "Enter valid name." },
            }}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Card expiry"
            name="cardexpirydate"
            placeholder="As displayed on your ID"
            rules={{ required: "Card expiry is required" }}
            screenSpan="full-screen"
            type="date"
          />
          <Select
            label="* Card type"
            name="cardtype"
            rules={{ required: "Card type is required" }}
            placeholder="As displayed on your ID"
            selectOptions={["SHC", "HCC", "PCC"]}
            screenSpan="full-screen"
          />
        </>
      );
    case "New Zealand Passport":
      return (
        <>
          <Texfield
            label="* Passport number"
            name="number"
            placeholder="As displayed on your ID"
            rules={{
              required: "Passport number required",
              pattern: { value: NZ_PASSPORT_NUMBER, message: "Enter a valid passport number" },
            }}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Passport expiry"
            name="expiry"
            placeholder="As displayed on your ID"
            rules={{ required: "Passport expiry is required" }}
            screenSpan="full-screen"
            type="date"
          />
        </>
      );
    case "New Zealand Drivers Licence":
      return (
        <>
          <Texfield
            label="* Licence number"
            name="number"
            placeholder="As displayed on your ID"
            rules={{
              required: "Licence number required",
              pattern: { value: NZ_DRIVERS_LICENSE_NUMBER, message: "Enter a valid license number" },
            }}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Licence version"
            name="version"
            placeholder="As displayed on your ID"
            rules={{
              required: "Licence version required",
              pattern: { value: NZ_DRIVERS_LICENSE_VERSION, message: "Enter a valid license version" },
            }}
            screenSpan="full-screen"
          />
        </>
      );
    default:
      return (
        <>
          <Select
            label="* State"
            name="state"
            rules={{ required: "State is required" }}
            placeholder="As displayed on your ID"
            selectOptions={states}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Licence number"
            name="number"
            placeholder="As displayed on your ID"
            rules={{
              required: "Licence number required",
              maxLength: { value: 10, message: "Maximum 10 characters" },
              pattern: { value: AUSTRALIAN_DRIVERS_LICENSE_NUMBER, message: "Enter a valid number." },
            }}
            screenSpan="full-screen"
          />
          <Texfield
            label="* Card number"
            name="cardNumber"
            placeholder="As displayed on your ID"
            rules={{
              required: "Card number required",
              minLength: { value: 7, message: "Should be between 7 - 10 characters" },
              maxLength: { value: 10, message: "Should be between 7 - 10 characters" },
              pattern: { value: AUSTRALIAN_DRIVERS_LICENSE_CARD_NUMBER, message: "Enter a valid card number" },
            }}
            screenSpan="full-screen"
          />
        </>
      );
  }
};

export default IdCheckModalDocumentSection;
